import CodeBlock from "./CodeBlock";

## Basic JSON

<CodeBlock
  code={{
    name: "Example",
    value: 42,
    active: true,
  }}
/>

---

## Complex Object

<CodeBlock
  code={{
    user: {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      roles: ["admin", "editor"],
    },
    settings: {
      theme: "dark",
      notifications: true,
      language: "en",
    },
    metadata: {
      created: "2024-01-15T10:30:00Z",
      updated: null,
    },
  }}
/>

---

## Array Data

<CodeBlock
  code={[
    { id: 1, name: "Item One", status: "active" },
    { id: 2, name: "Item Two", status: "pending" },
    { id: 3, name: "Item Three", status: "completed" },
  ]}
/>

---

## String Input

You can also pass a pre-formatted JSON string:

<CodeBlock code='{"message": "Hello, World!", "count": 100, "enabled": false}' />

---

## Nested Structure

<CodeBlock
  code={{
    project: {
      name: "My Project",
      version: "1.0.0",
      dependencies: {
        react: "^18.0.0",
        typescript: "^5.0.0",
      },
      devDependencies: {
        jest: "^29.0.0",
        eslint: "^8.0.0",
      },
    },
    config: {
      build: {
        output: "./dist",
        minify: true,
        sourceMaps: false,
      },
    },
  }}
/>

---

## API Response Example

<CodeBlock
  code={{
    status: 200,
    success: true,
    data: {
      items: [
        { id: "abc123", title: "First Post" },
        { id: "def456", title: "Second Post" },
      ],
      pagination: {
        page: 1,
        total: 42,
        hasMore: true,
      },
    },
    error: null,
  }}
/>


